import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MdEdit } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";


export default function useColumnsEstablcm(esUsuarioGestor, muestraBtnDesactivar, togglePop, togglePopDesactiva, guardarSelectedEstablecimiento, eliminarSelectedEstablecimiento) {

	const [t] = useTranslation("global");

	const onEditarEstablecimiento = (establecimiento) => {
		guardarSelectedEstablecimiento(establecimiento);
		togglePop();
	}
	
	const onDesactivarEstablecimiento = (establecimiento) => {
		eliminarSelectedEstablecimiento(establecimiento);
		togglePopDesactiva();
	}

	const columns = useMemo(
		() => [
			{
				Header: t("app.establecimiento.table.nombre"),
				Cell: ({ row }) => (
					<div>
						<p className="letra-negro-columna">{row.original.nombre}</p>
						<p className="letra-grisClaro-columna">{row.original.cadena.nombre}</p>
					</div>
				)
			},
			{
				Header: t("app.establecimiento.table.pais"),
				Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.pais.nombre} /</p>
						<p className="letra-grisClaro-columna">{row.original.localidadActividad}</p>
					</div>
				)
			},
			{
				Header: t("app.establecimiento.table.direccionActividad"),
				Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.direccionActividad}</p>
					</div>
				)
			},
			{
				Header: t("app.establecimiento.table.cpActividad"),
				Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.cpActividad}</p>
					</div>
				)
			},
			/*{
				Header: t("app.establecimiento.table.mailAdmin"),
				Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.mailAdmin}</p>
					</div>
				)
			},*/
			/*{
				Header: t("app.establecimiento.table.telefonoRecepcion"),
				Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.telefonoRecepcion}</p>
					</div>
				)
			},*/
			/*{
				Header: t("app.establecimiento.table.mailMantenimiento"),
				Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.mailMantenimiento}</p>
					</div>
				)
			},*/
			{
				accessor: 'action',
				Cell: ({ row }) => (
					<div className={'container-actionsTabla'}>
						<button className={'button-actionRecord'} onClick={(e) => onEditarEstablecimiento(row.original, e)}><FaEdit size='20' className={'icon-button-editarRecord'}/></button>
						{(muestraBtnDesactivar && esUsuarioGestor == false) && (<button className={'button-actionRecord'} onClick={(e) => onDesactivarEstablecimiento(row.original, e)}><MdDelete size='20' className={'icon-button-editarRecord'}/></button>)}
						
					</div>
				)
			}
		],
		[t, muestraBtnDesactivar, esUsuarioGestor]
	);

	return columns;
}